import manager from '@/services/manager'

import moment from 'moment'
import cookies from 'js-cookie'

// initial state
const state = {
  token: cookies.getJSON("eta-token") || null,
}

// getters
const getters = {
  status: (state, getters, rootState) => {
    if ((state.token == null) || (state.token.bearer == null) || (state.token.bearer.expires_at == null))
      return false;

    return moment(state.token.bearer.expires_at) > moment.utc();
  },
  token: (state, getters) => {
    return state.token != null ? state.token.bearer : null;
  },
  info: (state, getters) => {
    return state.token != null ? state.token.info : {};
  }
}

// actions
const actions = {
  setToken({
    state,
    commit,
  }, payload) {
    commit('setToken', {
      token: payload.token
    });
  },
  updateToken({
    state,
    commit,
  }, payload) {
    commit('updateToken', {
      properties: payload.properties
    });
  },
  updateTokenCompany({
    state,
    commit,
  }, payload) {
    commit('updateTokenCompany', {
      properties: payload.properties
    });
  },
  signOut({
    state,
    commit,
  }) {
    commit('setToken', {
      token: null
    });
  },
}

// mutations
const mutations = {
  setToken(state, {
    token
  }) {
    state.token = token;
  },
  updateToken(state, {
    properties
  }) {
    for (let property in properties) {
      if (!properties.hasOwnProperty(property)) return;

      if (property in state.token.info) {
        state.token.info[property] = properties[property];
      }
    }
  },
  updateTokenCompany(state, {
    properties
  }) {
    for (let property in properties) {
      if (!properties.hasOwnProperty(property)) return;

      if (property in state.token.info.company) {
        state.token.info.company[property] = properties[property];
      }
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
